<template>
  <div id="app" v-bind:class="iframeType">
    <InstagramWidget :data="data" :widget-id="widgetId" v-if="mounted && iframeType === 'instagram'"/>
    <InstagramModal :data="data" :widget-id="widgetId" v-if="mounted && iframeType === 'instagram-modal'"/>
    <ReputationWidget :data="data" :widget-id="widgetId" v-if="mounted && iframeType === 'reputation'" :theme="iframeTheme"/>
    <ReputationModal :data="data" :widget-id="widgetId" v-if="mounted && iframeType === 'reputation-modal'" :theme="iframeTheme"/>
    <ChannelWidget :data="data" :widget-id="widgetId"  v-if="mounted && iframeType === 'channel'" :theme="iframeTheme"/>
    <ReviewsWidget :data="data" :widget-id="widgetId" v-if="mounted && iframeType === 'reviews'" />
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from "axios"
  import InstagramWidget from './components/InstagramWidget.vue'
  import InstagramModal from './components/InstagramModal.vue'
  import ReputationWidget from "./components/ReputationWidget";
  import ReputationModal from "./components/ReputationModal";
  import ChannelWidget from './components/ChannelWidget.vue';
  import ReviewsWidget from './components/ReviewsWidget.vue';

export default {
  name: 'app',
  components: {
    InstagramWidget,
    InstagramModal,
    ReputationWidget,
    ReputationModal,
    ChannelWidget,
    ReviewsWidget
},
  data: function() {
    return {
      widgetId: null,
      mounted: false,
      data: false,
      iframeType: '',
      iframeTheme: 'light',
      reviewWidgetParams: ['lang', 'sort', 'limit', 'channels']
    }
  },
  methods: {
    getUrlParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  },
    async getWidgetData() {
      const urlParams = new URLSearchParams(window.location.search);
      const widgetID = urlParams.get('widgetID');
      const widgetType = urlParams.get('type');

      
      this.widgetId = widgetID

      const requestParams = new URLSearchParams();
      if (widgetType === 'channel' || widgetType === 'reviews') {
        requestParams.set('type', widgetType);
      }
      this.reviewWidgetParams.forEach((key) => {
        const value = urlParams.get(key);
        if (value) {
          requestParams.set(key, value);
        }
      });

      const url = this.iframeType.indexOf('instagram') > -1
        ? `${process.env.VUE_APP_GUESTFLIP_API_BASE_URL}/widget/${widgetID}`
        : `${process.env.VUE_APP_GUESTFLIP_API_BASE_URL_REPUTATION}/widget/${widgetID}${requestParams.toString() ? `?${requestParams.toString()}` : ''}`

      const results = await axios.get(url)
      const data = await results.data
      Vue.set(this, 'data', data)
    }
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const iframeType = urlParams.get('type');
    const iframeTheme = urlParams.get('theme') ? urlParams.get('theme') : 'light';

    this.iframeType = iframeType
    this.iframeTheme = iframeTheme

    await this.getWidgetData()

    this.mounted = true
  }
}
</script>

<style>

</style>
